// @flow
import React from 'react'
import styled from 'styled-components'
import colors from '../../styles/colors'
import theme from '../../styles/theme'

const Component = styled.button`
  color: ${(props) => (props.color ? colors[props.color] : colors.primary)};
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  outline: none;

  &:hover {
    color: ${(props) =>
      props.color ? theme[props.color].darken(0.2) : theme.primary.darken(0.2)}
    text-decoration: underline;
  }
`

type Props = {
  children?: any,
  style?: Object,
  onClick: Function,
  type?: 'submit' | 'button'
}

const LinkButton = ({ children, style, onClick, type, ...rest }: Props) => (
  <Component onClick={onClick} style={style} type={type} {...rest}>
    {children}
  </Component>
)

export default LinkButton



// WEBPACK FOOTER //
// ./src/components/LinkButton/index.js